"use client";

import { Wallet, Clock, ArrowRight, Sparkles } from "lucide-react";
import { PulseLoader } from "react-spinners";

const ComingSoon = () => {
  return (
    <div className="min-h-[80vh] bg-gradient-to-br rounded-2xl from-[#0F1419] via-[#131B24] to-[#1A1F2B] text-white flex flex-col items-center justify-center px-4">
      {/* Floating subtle background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -left-20 top-20 w-96 h-96 bg-[#61CE70]/5 rounded-full blur-3xl animate-pulse-slow" />
        <div className="absolute -right-20 bottom-20 w-80 h-80 bg-[#50B060]/5 rounded-full blur-3xl animate-pulse-slow delay-1000" />
      </div>

      <div className="relative z-10 text-center max-w-2xl">
        {/* Logo / Brand mark */}
        <div className="mb-10 flex justify-center">
          <div className="relative">
            <Wallet className="w-20 h-20 text-[#61CE70] animate-pulse" />
            <Sparkles className="w-6 h-6 text-[#7EE68A] absolute -top-2 -right-2 animate-spin-slow" />
          </div>
        </div>

        {/* Main Title */}
        <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold tracking-tight mb-4">
          <span className="bg-gradient-to-r from-[#61CE70] to-[#50B060] bg-clip-text text-transparent">
            Coming Soon
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl sm:text-2xl text-gray-300 mb-10 max-w-lg mx-auto">
          We're crafting something powerful for the next generation of finance
        </p>

        {/* Loading indicator + animation */}
        <div className="flex flex-col items-center gap-6 mb-12">
          <PulseLoader
            color="#61CE70"
            size={14}
            margin={6}
            speedMultiplier={0.8}
          />

          <div className="flex items-center gap-2 text-gray-400 text-sm font-medium tracking-wider uppercase">
            <Clock className="w-4 h-4 animate-pulse" />
            <span>Launching Soon</span>
          </div>
        </div>

        {/* Teaser / Call to action style */}
        <div className="inline-flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-[#61CE70]/10 to-[#50B060]/10 border border-[#61CE70]/30 rounded-2xl backdrop-blur-sm">
          <span className="text-[#A7E9B3]">Get ready for something big</span>
          <ArrowRight className="w-5 h-5 text-[#61CE70] animate-bounce-x" />
        </div>

        {/* Optional small footer text */}
        <p className="mt-16 text-sm text-gray-500">
          © {new Date().getFullYear()} CashTap • All rights reserved
        </p>
      </div>

      {/* Custom animations */}
      <style>{`
        @keyframes pulse-slow {
          0%,
          100% {
            opacity: 0.15;
            transform: scale(1);
          }
          50% {
            opacity: 0.35;
            transform: scale(1.15);
          }
        }

        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes bounce-x {
          0%,
          100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(6px);
          }
        }

        .animate-pulse-slow {
          animation: pulse-slow 8s infinite ease-in-out;
        }

        .animate-spin-slow {
          animation: spin-slow 20s linear infinite;
        }

        .animate-bounce-x {
          animation: bounce-x 2s infinite ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default ComingSoon;
